import React, { useState } from "react";
import imgurl from "../assets/images/imgUrl";
import { TextField, Card, CardContent, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import { getOtp } from "../api/api";
import { toast } from "react-toastify";
import axios from "axios";
import MainLoader from "../components/MainLoader";

function LoginPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  // country code
  const [countryCode, setCountryCode] = useState("34");
  const [mobileNumber, setMobileNumber] = useState("");
  const [error, setError] = useState("");
  const handleCountryCodeChange = (event) => {
    setCountryCode(event.target.value);
  };

  const handleRequestCode = () => {
    if (mobileNumber.length < 9) {
      setError("Please enter a valid mobile number");
      return;
    }
    const fullNumber = `+${countryCode}${mobileNumber}`;
    navigate("/otp-page", {
      state: { mobileNumber: fullNumber },
    });
  };

  const handleGetOtp = async () => {
    const fullNumber = `+${countryCode}${mobileNumber}`;
    if (mobileNumber.length < 9) {
      setError("Please enter a valid mobile number");
      return;
    }
    let reqBody = {
      user_no: fullNumber,
    };
    setLoading(true);
    try {
      const response = await axios.post(getOtp, reqBody);
      setLoading(false);
      if (response.status == 200) {
        toast.success("Verification code has been sent");
        navigate("/otp-page", {
          state: { mobileNumber: fullNumber },
        });
      }
    } catch (error) {
      setLoading(false);
    }
  };
  return (
    <>
      {loading && <MainLoader />}

      <Grid container spacing={0} className="loginpage">
        {/* <Grid size={{ xs: 12, md: 7 }} className="homeBgImg">
      
        </Grid> */}
        <Grid size={{ xs: 12, md: 12 }}>
          <div className="d-flex justify-content-center align-items-center flex-direction-column">
            <div className="siteLogoWrapper">
              <img src={imgurl.alopexiaLogo} />
              <h5>Compounder</h5>
            </div>
            <Card className="otpcard loginpginput">
              <CardContent className="pb-16px userProfileCardContainer">
                {/* <div className="loginpglogo">
                            <img src={imgurl.hairlossaiLogo} alt="New Logo" />
                        </div> */}
                <div className="otppgtext">
                  <p>Sign In with Mobile Number</p>
                </div>

                <Grid container spacing={0} className="otptextfield">
                  <Grid size={{ xs: 12 }}>
                    <Select
                      value={countryCode}
                      onChange={handleCountryCodeChange}
                      className="country-select"
                      disableUnderline
                    >
                      <MenuItem value="33">
                        <div className="d-flex justify-content-start align-items-center">
                          <div>
                            <img
                              src={imgurl.france}
                              alt="Country Flag"
                              className="flag"
                            />
                          </div>
                          <div className="d-flex justify-content-center align-items-center w-100">
                            France (+33)
                          </div>
                        </div>
                      </MenuItem>
                      <MenuItem value="34">
                        <div className="d-flex justify-content-start align-items-center">
                          <div>
                            <img
                              src={imgurl.spain}
                              alt="Country Flag"
                              className="flag"
                            />
                          </div>
                          <div className="d-flex justify-content-center align-items-center w-100">
                            Spain (+34)
                          </div>
                        </div>
                      </MenuItem>
                      <MenuItem value="39">
                        <div className="d-flex justify-content-start align-items-center">
                          <div>
                            <img
                              src={imgurl.italy}
                              alt="Country Flag"
                              className="flag"
                            />
                          </div>
                          <div className="d-flex justify-content-center align-items-center w-100">
                            Italy (+39)
                          </div>
                        </div>
                      </MenuItem>

                      <MenuItem value="41">
                        <div className="d-flex justify-content-start align-items-center">
                          <div>
                            <img
                              src={imgurl.switzerland}
                              alt="Country Flag"
                              className="flag"
                            />
                          </div>
                          <div className="d-flex justify-content-center align-items-center w-100">
                            Switzerland (+41)
                          </div>
                        </div>
                      </MenuItem>

                      <MenuItem value="91">
                        <div className="d-flex justify-content-start align-items-center">
                          <div>
                            <img
                              src={imgurl.flag1}
                              alt="Country Flag"
                              className="flag"
                            />
                          </div>
                          <div className="d-flex justify-content-center align-items-center w-100">
                            India (+91)
                          </div>
                        </div>
                      </MenuItem>
                    </Select>
                  </Grid>
                  <Grid size={{ xs: 12 }} className="mt-20px">
                    <TextField
                      id="outlined-basic"
                      type="tel"
                      label=""
                      variant="outlined"
                      placeholder="Enter Mobile Number"
                      className="whitefield"
                      value={mobileNumber}
                      onChange={(e) => {
                        const value = e.target.value
                          .replace(/\D/g, "")
                          .slice(0, 10);
                        setMobileNumber(value);
                        if (error && value.length > 0) setError("");
                      }}
                      error={!!error}
                      helperText={error}
                      slotProps={{
                        formHelperText: {
                          className: "error-text",
                        },
                      }}
                    />
                  </Grid>
                </Grid>

                <Button
                  variant="contained"
                  className="textTransformUnset commonButton mt-40px verification-button"
                  //   onClick={handleRequestCode}

                  // onClick={handleRequestCode}
                  onClick={handleGetOtp}
                >
                  Get Verification Code
                </Button>
              </CardContent>
            </Card>
          </div>
        </Grid>
      </Grid>
    </>
  );
}

export default LoginPage;
